import { BaSeLoading, BaSeParagraph, BaSeSmall1, BaSeTheme } from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  RadialLinearScale,
  Title,
  Tooltip,
} from 'chart.js';
import React from 'react';

import { Radar } from 'react-chartjs-2';
import { useReport } from '../hook/useReport';
import {
  AlignText,
  Container,
  ContentGraph,
  HeaderInfo,
} from './pyramid-chart-style';

const DEFAULT_DATA = {
  labels: [`Vendedor `, `Criativo `, `Analítico `],
  datasets: [
    {
      label: '',
      data: [5, 3, 1],
      fill: true,
      backgroundColor: 'rgba(54, 162, 235, 0.2)',
      borderColor: 'rgba(208, 175, 82, 1)',
      borderWidth: 2,
    },
  ],
};
function PyramidChart() {
  ChartJS.register(
    CategoryScale,
    ArcElement,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    RadialLinearScale,
    PointElement,
    LineElement,
  );

  const { getRouteParam } = Sebrae.useSebraeRouter();
  const { getStepData, laoding } = useReport();
  const [data, setData] = React.useState(DEFAULT_DATA);
  const [desc, setDesc] = React.useState('');
  const [showStep, setShowStep] = React.useState();
  const [erro, setErro] = React.useState();

  React.useEffect(() => {
    getStepData({
      cpf: getRouteParam('cpf'),
      step: 'CRIATIVO_ANALITICO_VENDEDOR',
    })
      .then((response) => {
        setDesc({
          description: response.data.descProfile,
          title: response.data.profile,
        });
        const responseFormated = {
          labels: [
            `Vendedor ${response?.data?.sellerQuantity}`,
            `Criativo ${response?.data?.creativeQuantity}`,
            `Analítico ${response?.data?.analyticalQuantity}`,
          ],
          datasets: [
            {
              label: '',
              data: [
                response.data.sellerQuantity,
                response.data.creativeQuantity,
                response.data.analyticalQuantity,
              ],
              backgroundColor: 'rgba(54, 162, 235, 0.2)',
              borderColor: 'rgba(208, 175, 82, 1)',
              borderWidth: 2,
            },
          ],
        };

        setData(responseFormated);
        setShowStep(response.showStep);
      })
      .catch((error) => {
        setErro(error);
        console.log('deu erro', error);
      });
  }, [getRouteParam, getStepData]);

  const options = {
    responsive: true,
    scales: {
      r: {
        angleLines: {
          display: true,
        },
        suggestedMax: 6,
        suggestedMin: 0,
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
        text: 'Gráfico de Barras Horizontal',
      },
    },
  };

  if (laoding) {
    return (
      <BaSeLoading
        backgroundColor="#fff"
        description=""
        lightMode="default"
        shadowLevel={0}
        spinnerColor=""
        spinnerSize={24}
        text="Carregando…"
        textColor=""
      />
    );
  }
  if (!showStep) {
    return <> </>;
  }
  return (
    <>
      <BaSeParagraph color={BaSeTheme.colors.gestao.cinza10} isBold>
        CRIATIVO, ANALÍTICO E VENDEDOR
      </BaSeParagraph>
      {erro ? (
        'Não foi possigel carregar dados para essa sessão do relatório!'
      ) : (
        <Container>
          <ContentGraph>
            <Radar data={data} options={options} />
          </ContentGraph>
          <div>
            <HeaderInfo>
              <BaSeParagraph color={'#C5EAFF'}>{desc.title}</BaSeParagraph>
            </HeaderInfo>
            <AlignText>
              <BaSeSmall1>
                <span
                  dangerouslySetInnerHTML={{
                    __html: desc.description,
                  }}
                ></span>
              </BaSeSmall1>
            </AlignText>
          </div>
        </Container>
      )}
    </>
  );
}

export default PyramidChart;
